<template>
  <div v-show="errorTip" style="margin-left: 30px">
    <Alert type="warning" show-icon>
      {{ $t("alarms.common.warning") }}
      <template slot="desc">{{ $t("alarms.common.phoneTip") }}</template>
    </Alert>
  </div>
</template>
<script>
export default {
  name: "PhoneWarning",
  data() {
    return {
      errorTip: true,
    };
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/monitor/common/PhoneWarning.vue